import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  breadcrumbs: {
    id: 'studio.ByoZDD',
    defaultMessage: 'Breadcrumbs',
  },
});
